/** Referências da atividade*/
export interface AtividadeReferencia {
    id: number;
    nome: string;
}

export const referenciaCliente: AtividadeReferencia = {id: 1, nome: 'Cliente'};
export const referenciaLead: AtividadeReferencia = {id: 2, nome: 'Lead'};

export const atividadeReferencias: AtividadeReferencia[] = [
    referenciaCliente,
    referenciaLead
];


/** Verifica se a referência da atividade é a cliente */
export function isReferenciaCliente(id: number): boolean {
    return id === referenciaCliente.id;
}

/** Verifica se a referência da atividade é a lead */
export function isReferenciaLead(id: number): boolean {
    return id === referenciaLead.id;
}
